module.exports = __webpack_public_path__ + "media/customizations/viridian/back-fa8b2bbd45d08fedbe8bc614e58e48ea.jpg";